export const RESEARCHER = 'researcher'
export const PROGRAM_MANAGER = 'program_manager'
export const APPLICATION_OWNER = 'application_owner'
export const BANKER = 'banker'

export default [RESEARCHER, PROGRAM_MANAGER, APPLICATION_OWNER, BANKER]
